import { apiBaseURL } from "../ProjectConstants";

export async function handlePostComments(
  orderId,
  comment,
  userId,
  today,
  fetch,
) {
  const body = {
    orderId: orderId,
    comment: comment,
    userId: userId,
    today: today,
  };
  console.log(" before handlePostComments =>", body);

  //   const response = null;
  const response = await fetch.post(`${apiBaseURL}/api/Order/Comments`, body);
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";

  console.log("handlePostComments body", body, response);

  return {
    response,
    isDataGood,
  };
}
